<template>
  <div class="">
     <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
      <div style="min-height:70vh">
        <div class="title">
          <div class="title-line"></div>
          <span>测算结果</span>
        </div>

        <div class="pk">
          <img :src="data.poker" alt="" />
        </div>

        <div class="text">
          <div v-html="data.content"></div>
        </div>
      </div>

      <div class="bottom-btn">
        <!-- <div class="ps">温馨提示:本测算仅供参考，切勿过于当真!</div> -->
        <font></font>
        <!-- <div class="start-btn" @click="$router.back()">重来一次</div> -->
        <btn></btn>
      </div>
      <div style="height: 1rem"></div>
    </div>

  </div>
</template>

<script>
/**
@description:扑克占卜结果
@createTime:2021-08-25
@create:wq
*/
import topTab from "@/components/topTab";

import font from "@/components/font";
import btn from "@/components/publicBtn";

export default {
  name: "",
  props: {},
  components: { topTab ,font,btn},

  data() {
    return {
      data: "",
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'扑克占卜',
        path:'/pk'
      },{
        name:'扑克占卜'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    const data = localStorage.getItem("result");
    if (data) this.data = JSON.parse(data);
  },
  destroyed() {
    localStorage.removeItem("result");
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0 0.24rem;
}
.res {
  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  margin-bottom: 1rem;
}

.title {
  display: flex;
  align-items: center;
  margin-top: 0.38rem;
  font-weight: bold;
  font-size: 0.3rem;
  font-weight: 400;
  color: #333333;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  white-space: pre-wrap;
  p {
    text-indent: 2em;
  }
}
.bottom-btn {
  margin: 0 auto;
  margin-top: 0.5rem;
  // position: fixed;
  // bottom: 1.2rem;
  // left: 50%;
  // transform: translateX(-50%);
  .ps {
    font-size: 0.24rem;
    font-weight: 400;
    color: #f9647d;
    text-align: center;
    margin-bottom: 0.18rem;
  }
}
.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
.pk {
  height: 4rem;
  background: #f0f0f0;
  margin-top: 0.16rem;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 1.74rem;
  }
}

</style>
